/**
 * SparkChart — a compact SVG sparkline with a gradient area fill and
 * marker dot. Used to give project tiles a "live data" texture.
 * seed: deterministic 0..N points normalized 0..1
 */
export default function SparkChart({
  points = [0.2, 0.35, 0.28, 0.52, 0.48, 0.68, 0.62, 0.82, 0.9],
  width = 140,
  height = 44,
  stroke = "#00D4FF",
  fill = "#6D4DFF",
  className = "",
}) {
  const w = width;
  const h = height;
  const pad = 3;
  const step = (w - pad * 2) / (points.length - 1);

  const toXY = (v, i) => {
    const x = pad + i * step;
    const y = h - pad - v * (h - pad * 2);
    return [x, y];
  };

  const path = points
    .map((v, i) => {
      const [x, y] = toXY(v, i);
      return `${i === 0 ? "M" : "L"}${x.toFixed(1)} ${y.toFixed(1)}`;
    })
    .join(" ");

  const area = `${path} L${w - pad} ${h - pad} L${pad} ${h - pad} Z`;
  const last = points[points.length - 1];
  const [lx, ly] = toXY(last, points.length - 1);
  const gradId = `sparkGrad-${Math.random().toString(36).slice(2, 8)}`;

  return (
    <svg
      viewBox={`0 0 ${w} ${h}`}
      width={w}
      height={h}
      className={className}
      aria-hidden="true"
    >
      <defs>
        <linearGradient id={gradId} x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor={fill} stopOpacity="0.35" />
          <stop offset="100%" stopColor={fill} stopOpacity="0" />
        </linearGradient>
      </defs>
      <path d={area} fill={`url(#${gradId})`} />
      <path d={path} fill="none" stroke={stroke} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <circle cx={lx} cy={ly} r="2.6" fill={stroke} />
      <circle cx={lx} cy={ly} r="6" fill={stroke} opacity="0.18" />
    </svg>
  );
}
